import { FeiertagskontoContent } from '@/domain/mitarbeiter/features/feiertagskonto/features/feiertagskonto/FeiertagskontoContent';
import { KontoausgleichDesktop } from '@/domain/mitarbeiter/features/feiertagskonto/features/kontoausgleich/KontoausgleichDesktop';

export function FeiertagskontoContentDesktop() {
  return (
    <div className="flex flex-col gap-8">
      <FeiertagskontoContent className={'flex-row'} />
      <KontoausgleichDesktop />
    </div>
  );
}
